import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AboutYourMentorBlock from '../components/AboutYourMentorBlock';
import DesktopAppIconModal from '../components/DesktopAppIconModal';
import LivingRoomConsole, { BRIEFING_ROOM_WELCOME } from '../components/LivingRoomConsole';
import LivingRoomQrModal from '../components/LivingRoomQrModal';
import {
  DESKTOP_ICON_MENU_LABEL,
  PHONE_QR_MENU_LABEL,
} from '../lib/desktopAppIcon';
import { SCREENS } from '../lib/screenRegistry';

const CORPORATE_WELCOME = BRIEFING_ROOM_WELCOME;

const SUBSCRIPTION_ID = 'ELT-ORG-DEV-9842';

export default function CorporateMenteeLounge() {
  const navigate = useNavigate();
  const [qrOpen, setQrOpen] = useState(false);
  const [desktopIconOpen, setDesktopIconOpen] = useState(false);

  return (
    <LivingRoomConsole
      screenId={SCREENS.ELT09}
      welcomeScript={CORPORATE_WELCOME}
      assetBlocks={<AboutYourMentorBlock />}
      menuContent={(closeMenu) => (
        <>
          <p className="living-room-util-item living-room-util-static">
            Subscription: {SUBSCRIPTION_ID}
          </p>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              navigate('/elt-setup');
            }}
          >
            Change setup
          </button>
          <a
            className="living-room-util-item"
            href="mailto:support@mentology.com.au?subject=Contact%20My%20Mentor"
            onClick={closeMenu}
          >
            Contact My Mentor
          </a>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              setDesktopIconOpen(true);
            }}
          >
            {DESKTOP_ICON_MENU_LABEL}
          </button>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              setQrOpen(true);
            }}
          >
            {PHONE_QR_MENU_LABEL}
          </button>
        </>
      )}
      qrModal={
        <>
          {qrOpen ? (
            <LivingRoomQrModal
              titleId="corporate-lounge-qr-title"
              onClose={() => setQrOpen(false)}
            />
          ) : null}
          {desktopIconOpen ? (
            <DesktopAppIconModal
              titleId="corporate-lounge-desktop-icon-title"
              onClose={() => setDesktopIconOpen(false)}
            />
          ) : null}
        </>
      }
    />
  );
}
